/* Pure presentation catalog. The Worker remains authoritative for price and stock. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.BoAovCatalog = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var families = {
    '42562312699974': 'tiras', '42562312667206': 'tiras', '42562312634438': 'tiras',
    '46069797617734': 'tapones',
    '41019179204678': 'lentes', '41004276318278': 'lentes',
    '44464796860486': 'dilatador', '44464796893254': 'dilatador',
    '44452590387270': 'stickers', '43188148371526': 'cinta'
  };
  var prices = { tiras: 18000, tapones: 25000, lentes: 40000, dilatador: 30000, stickers: 16000, cinta: 18000 };
  var rules = [
    {key: 'tiras-tapones', title: '30 tiras + tapones', counts: {tiras: 1, tapones: 1}, goods: 43000},
    {key: 'dos-tiras-tapones', title: '60 tiras + tapones', counts: {tiras: 2, tapones: 1}, goods: 50000, comparison: 55000},
    {key: 'lentes-tiras', title: 'Lentes + 30 tiras', counts: {lentes: 1, tiras: 1}, goods: 50000},
    {key: 'lentes-tapones', title: 'Lentes + tapones', counts: {lentes: 1, tapones: 1}, goods: 60000},
    {key: 'dilatador-tapones', title: 'Kit dilatador + tapones', counts: {dilatador: 1, tapones: 1}, goods: 50000},
    {key: 'dilatador-repuesto-tapones', title: 'Kit dilatador + repuesto + tapones', counts: {dilatador: 1, stickers: 1, tapones: 1}, goods: 60000, comparison: 65000},
    {key: 'lentes-tiras-tapones', title: 'Lentes + 30 tiras + tapones', counts: {lentes: 1, tiras: 1, tapones: 1}, goods: 70000}
  ];
  function variantNumber(value) {
    if (typeof value === 'string') {
      if (!/^[1-9]\d*$/.test(value)) return null;
      value = Number(value);
    }
    return typeof value === 'number' && Number.isSafeInteger(value) && value > 0 ? value : null;
  }
  function family(variantId) {
    var id = variantNumber(variantId);
    return id === null ? null : families[id] || null;
  }
  function normalize(items) {
    if (!Array.isArray(items) || items.length === 0) return null;
    var totals = new Map();
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item || typeof item !== 'object') return null;
      var id = variantNumber(item.variantId);
      var quantity = item.quantity;
      if (id === null || typeof quantity !== 'number' || !Number.isSafeInteger(quantity) || quantity <= 0) return null;
      var sum = (totals.get(id) || 0) + quantity;
      if (!Number.isSafeInteger(sum)) return null;
      totals.set(id, sum);
    }
    return Array.from(totals, function (pair) { return {variantId: pair[0], quantity: pair[1]}; })
      .sort(function (a, b) { return a.variantId - b.variantId; });
  }
  function match(items) {
    var normalized = normalize(items);
    if (!normalized) return null;
    var counts = Object.create(null), subtotal = 0;
    for (var i = 0; i < normalized.length; i++) {
      var item = normalized[i], name = family(item.variantId);
      if (!name) return null;
      counts[name] = (counts[name] || 0) + item.quantity;
      subtotal += prices[name] * item.quantity;
      if (!Number.isSafeInteger(counts[name]) || !Number.isSafeInteger(subtotal)) return null;
    }
    for (var r = 0; r < rules.length; r++) {
      var rule = rules[r], names = Object.keys(rule.counts);
      if (Object.keys(counts).length !== names.length || !names.every(function (name) { return counts[name] === rule.counts[name]; })) continue;
      var comparison = rule.comparison || subtotal;
      return {key: rule.key, pricingVersion: 'bio-aov-2026-10-02', offerId: 'aov-kit-v1', items: normalized,
        subtotalCents: subtotal, discountCents: subtotal - rule.goods, goodsCents: rule.goods,
        comparisonCents: comparison, savingsCents: comparison - rule.goods};
    }
    return null;
  }
  function presets(lensId, stripId, dilatorId) {
    if (family(lensId) !== 'lentes' || family(stripId) !== 'tiras' || family(dilatorId) !== 'dilatador') return [];
    var ids = {lentes: lensId, tiras: stripId, dilatador: dilatorId, tapones: 46069797617734, stickers: 44452590387270};
    return rules.map(function (rule) {
      var result = match(Object.keys(rule.counts).map(function (name) { return {variantId: ids[name], quantity: rule.counts[name]}; }));
      result.title = rule.title;
      return result;
    });
  }
  return Object.freeze({family: family, normalize: normalize, match: match, presets: presets});
}));
